import { useEffect } from 'react';
import { Modal, Form, Input, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateTransactionApprovalStatus, clearFlags } from '../../../store/slices/transactionApprovalSlice';
import { CustomButton } from '../CustomButton';
import CustomSelect from '../CustomSelect';
import Colors from '../../../utils/colors';
import { showToast } from '../../../utils/toast';
import Constants from '../../../utils/constants';

const UpdateApprovalStatusModal = ({ isOpen, onClose, approval }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading, isUpdated, error } = useSelector((state) => state.transactionApproval);

  useEffect(() => {
    if (approval && isOpen) {
      form.setFieldsValue({
        approvalStatus: approval.approvalStatus,
        remarks: approval.remarks || ''
      });
    }
  }, [approval, isOpen, form]);

  useEffect(() => {
    if (isUpdated) {
      showToast('Approval status updated successfully', 'success');
      form.resetFields();
      onClose();
      dispatch(clearFlags());
    }

    if (error) {
      showToast(error, 'error');
    }
  }, [isUpdated, error, form, onClose, dispatch]);

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const handleSubmit = (values) => {
    // Handle both populated and non-populated transactionId
    const transactionId = approval?.transactionId?._id || approval?.transactionId;
    
    if (!transactionId) {
      showToast('Transaction ID is missing', 'error');
      return;
    }

    dispatch(updateTransactionApprovalStatus({
      transactionId,
      approvalStatus: values.approvalStatus,
      remarks: values.remarks || ''
    }));
  };

  return (
    <Modal
      title="Update Approval Status"
      open={isOpen}
      onCancel={onClose}
      maskClosable={false}
      centered
      width={500}
      footer={null}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            name="approvalStatus"
            label="Approval Status"
            rules={[{ required: true, message: 'Please select approval status' }]}
          >
            <CustomSelect
              placeholder="Select approval status"
              disabled={loading}
              options={[
                { value: Constants.APPROVAL_STATUS.APPROVED, label: 'Approved' },
                { value: Constants.APPROVAL_STATUS.REJECTED, label: 'Rejected' }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="remarks"
            label="Remarks"
          >
            <Input.TextArea
              placeholder="Enter remarks (optional)"
              rows={4}
              maxLength={500}
              showCount
              disabled={loading}
              style={{ fontSize: '12px' }}
            />
          </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <CustomButton
              onClick={onClose}
              variant="outline"
              color={Colors.gray}
              disabled={loading}
            >
              Cancel
            </CustomButton>
            <CustomButton
              type="submit"
              variant="filled"
              color={Colors.primary}
              loading={loading}
            >
              Update Status
            </CustomButton>
          </div>
        </Form.Item>
      </Form>
      </Spin>
    </Modal>
  );
};

export default UpdateApprovalStatusModal;

